import api from './api';

const legalTermsMasterService = {
  // Get all legal terms
  getAllLegalTerms: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.category) queryParams.append('category', params.category);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/legal-terms-master${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching legal terms:', error);
      throw error;
    }
  },

  // Get legal terms by ID
  getLegalTermsById: async (id) => {
    try {
      const response = await api.get(`/legal-terms-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching legal terms:', error);
      throw error;
    }
  },

  // Get next legal terms code
  getNextLegalTermsCode: async () => {
    try {
      const response = await api.get('/legal-terms-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next legal terms code:', error);
      throw error;
    }
  },

  // Create legal terms template
  createLegalTerms: async (legalTermsData) => {
    try {
      const response = await api.post('/legal-terms-master', legalTermsData);
      return response.data;
    } catch (error) {
      console.error('Error creating legal terms:', error);
      throw error;
    }
  },

  // Update legal terms template
  updateLegalTerms: async (id, legalTermsData) => {
    try {
      const response = await api.put(`/legal-terms-master/${id}`, legalTermsData);
      return response.data;
    } catch (error) {
      console.error('Error updating legal terms:', error);
      throw error;
    }
  },

  // Delete legal terms template
  deleteLegalTerms: async (id) => {
    try {
      const response = await api.delete(`/legal-terms-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting legal terms:', error);
      throw error;
    }
  },

  // Get legal terms statistics
  getLegalTermsStats: async () => {
    try {
      const response = await api.get('/legal-terms-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching legal terms statistics:', error);
      throw error;
    }
  }
};

export default legalTermsMasterService;

